module.exports = __webpack_public_path__ + "static/media/20a-01-HOME_a.8a906816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20a/20a-01-HOME_a.jpg
// module id = 242
// module chunks = 0